import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const masterDataEthnicityListService = (
  params: Types.MasterDataEthnicityListRequest
) =>
  RestAPIClient.call<Types.MasterDataEthnicityListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const masterDataEthnicityListShortService = (
  params: Types.MasterDataEthnicityListRequest
) =>
  RestAPIClient.call<Types.MasterDataEthnicityListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });
